import React from 'react';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import PDFPreview from '../../images/preview.png';

class PreviewPDFButton extends React.Component {
  previewButtonHandler = () => {
    const { handlePreviewButton, installationDocumentId } = this.props;
    if (installationDocumentId !== null) {
      handlePreviewButton({ shipmentId: installationDocumentId });
    }
  }

  render() {
    return (
      <img src={PDFPreview} alt="pdf-preview" onClick={this.previewButtonHandler} width="30px" />
    );
  }
}

const mapStateToProps = (state) => ({
  currentLanguage: getActiveLanguage(state.locale).code,
  translate: getTranslate(state.locale),
  session: state.session,
});

export default connect(
  mapStateToProps,
  null,
)(PreviewPDFButton);



// WEBPACK FOOTER //
// ./src/components/servicereport/PreviewPDFButton.js